module.exports = __webpack_public_path__ + "img/firststop.ce906a35.png";